import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

export const useAuth = () => {
  const API_URL = import.meta.env.VITE_API_URL;
  const queryClient = useQueryClient();

  const { data : auth, isPending  } = useQuery({
   	queryKey: ['auth'],
   	queryFn: async () => {
   		const response = await fetch(`${API_URL}/bbs/ajax.auth.php`, {
     		credentials: 'include'
   		});

     	if (!response.ok) throw new Error("네트워크 오류");

 	  	return response.json();
   	},
   	staleTime: 0,
   	refetchOnWindowFocus: false,
   	retry: false
	});

	const logoutMutation = useMutation({
		mutationFn: async () => {
			await fetch(`${API_URL}/bbs/ajax.logout.php`, {
				method: 'POST',
				credentials: 'include'
			});
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['auth'] });
		}
	});

	return {
		userId: auth?.data?.memberId ?? null,
	  isAuth: auth?.success === true,
	  isAuthLoading: isPending,
	  logout: logoutMutation.mutate,
	};
};